import React from 'react';
import { teamMembers } from '../data/mock';
import { User } from 'lucide-react';

const Team = () => {
  return (
    <section id="team" className="py-24 bg-gradient-to-b from-white to-[#faf7f2]" aria-labelledby="team-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <header className="text-center mb-16">
          <span className="inline-block text-[#1a472a] font-semibold text-sm uppercase tracking-wider mb-4">
            Teamet
          </span>
          <h2 id="team-heading" className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Ildsjælene bag festen
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Mød de frivillige, der bruger utallige timer på at skabe magi for børnene.
          </p>
        </header>

        {/* Team Grid */}
        <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 list-none p-0" role="list">
          {teamMembers.map((member) => (
            <li
              key={member.id}
              className="group bg-white rounded-3xl p-8 shadow-lg shadow-gray-100 border border-gray-100 hover:border-[#1a472a]/20 text-center transition-all duration-300 hover:-translate-y-2"
              itemScope
              itemType="https://schema.org/Person"
            >
              {/* Avatar */}
              <div className="w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-[#1a472a] to-[#2d5a3d] rounded-full flex items-center justify-center shadow-lg shadow-[#1a472a]/20 group-hover:scale-110 transition-transform duration-300" aria-hidden="true">
                <User className="w-12 h-12 text-white/90" />
              </div>

              {/* Name */}
              <h3 className="text-xl font-bold text-gray-900 mb-2" itemProp="name">
                {member.name}
              </h3>

              {/* Role */}
              <p className="text-[#1a472a] font-semibold text-sm uppercase tracking-wider mb-4" itemProp="jobTitle">
                {member.role}
              </p>

              {/* Description */}
              <p className="text-gray-600 leading-relaxed" itemProp="description">
                {member.description}
              </p>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-4">
            Vil du være med til at gøre en forskel?
          </p>
          <a
            href="#kontakt"
            className="inline-flex items-center gap-2 text-[#1a472a] font-semibold hover:underline"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#kontakt')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Kontakt os og bliv frivillig
            <span aria-hidden="true">→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Team;
